import { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import { Box, IconButton, Snackbar, Alert } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { LanguageContext } from '../../../../../context/languageContext';
import { DataGridPremium, useGridApiRef } from '@mui/x-data-grid-premium';
import EditSkillingSheet from './editEsAuroraSkills';

export default function EsAuroraSkillingSheet({user}) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isEditSkillingSheetModalOpen, setisEditSkillingSheetModalOpen] =
    useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsSnackbarOpen(false);
  };
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const { translations } = useContext(LanguageContext);
  const apiRef = useGridApiRef();

  const skillingSheetReport = translations => ({
    apiEndpoint: `${process.env.REACT_APP_ENDPOINT_ADMIN}/workforce/skilling-sheet/es-aurora/get`,
    columns: [
      {
        field: 'name',
        headerName: 'Name',
        width: 200,
      },
      {
        field: 'location',
        headerName: 'Location',
        width: 200,
      },
      {
        field: 'california',
        headerName: 'California',
        width: 200,
      },
      {
        field: 'colorado',
        headerName: 'Colorado',
        width: 200,
      },
      {
        field: 'kentucky',
        headerName: 'Kentucky',
        width: 200,
      },
      {
        field: 'mississippi',
        headerName: 'Mississippi',
        width: 200,
      },
      {
        field: 'missouri',
        headerName: 'Missouri',
        width: 200,
      },
      {
        field: 'northCarolina',
        headerName: 'North Carolina',
        width: 200,
      },
      {
        field: 'edit',
        headerName: 'Edit',
        renderCell: params => {
          return (
            <IconButton
              onClick={() => handleEditSkillingSheetModalOpenClose(params.row)}
            >
              <EditIcon />
            </IconButton>
          );
        },
      },
    ],
  });

  const skillingSheet = skillingSheetReport(translations);

  const handleEditSkillingSheetModalOpenClose = entry => {
    setCurrentEntry(isEditSkillingSheetModalOpen ? null : entry);
    setisEditSkillingSheetModalOpen(!isEditSkillingSheetModalOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(skillingSheet.apiEndpoint);
      setData({
        rows: response.data,
      });
      setIsLoading(false);
    };
    fetchData();
  }, [skillingSheet.apiEndpoint]);

  const handleRefresh = async () => {
    const response = await axios.get(skillingSheet.apiEndpoint);
    setData({
      rows: response.data,
    });
  };

  return (
    <Box
      sx={{
        height: '90vh',
        width: '100%',
        display: 'flex',
        p: 2,
      }}
    >
      <DataGridPremium
        {...data}
        loading={isLoading}
        columns={skillingSheet.columns}
        disableRowSelectionOnClick
        showToolbar
        sx={{ fontFamily: 'BrightstarSans-Regular' }}
        apiRef={apiRef}
        initialState={{ pinnedColumns: { left: ['name'], right: ['edit'] } }}
      />
      {isEditSkillingSheetModalOpen && (
        <EditSkillingSheet
          handleRefresh={handleRefresh}
          isOpen={isEditSkillingSheetModalOpen}
          handleClose={handleEditSkillingSheetModalOpenClose}
          entry={currentEntry}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setSnackbarMessage={setSnackbarMessage}
          setSnackbarSeverity={setSnackbarSeverity}
          user={user}
        />
      )}
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          variant='filled'
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
